







import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class SecKill extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: {
      expriedTime: 0,
      memberScope: "All",
      cumulativeWithOtherDiscount: false
    }
  })
  value!: any;
}
